<!-- <mat-toolbar color="primary">
    <button [fxShow.lt-md]="true" [fxShow]="false"  mat-icon-button (click)="openSidenav()">
        <mat-icon>menu</mat-icon>
    </button>
    <span>Email Configuration</span>
</mat-toolbar> -->
<div class="content" fxLayout="column" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="16px" [@routeAnimation]="true">
    <mat-card fxLayout="column" style="padding: 0;">
        <div class="content" fxLayout.gt-md="row" fxLayout="column" fxLayoutGap="12px" style="padding-top: 30px;">
            <button mat-raised-button color="primary" (click)="onAddEmailTemplate()">Add Email Template</button>
            <button mat-raised-button color="primary" (click)="onComposeEmail()">Compose Email</button>
            <!-- <span class="fill-space"></span> -->
            <!-- <button mat-fab color="primary"><mat-icon>mail_outline</mat-icon></button> -->
        </div>
        <div class="content" fxLayout="column" fxLayout.gt-md="row" fxLayoutGap="16px" [@routeAnimation]="true">

            <mat-card *ngIf="!isNullEmailTemplates" fxFlex.gt-md="35%" fxLayoutAlign="stretch" style="margin: 0;">
                <!-- <button mat-raised-button color="primary" (click)="onAddEmailTemplate()">Add Email Template</button> -->
                <div style="width: 100%;">
                    <div class="override-container">
                        <div>
                            <mat-form-field class="filter">
                                <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
                            </mat-form-field>
                        </div>

                        <div class="override-loading-shade" *ngIf="isLoadingResults">
                            <mat-spinner *ngIf="isLoadingResults"></mat-spinner>
                        </div>

                        <mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">

                            <ng-container matColumnDef="emailTemplateName">
                                <mat-header-cell *matHeaderCellDef mat-sort-header> Email Template Name
                                </mat-header-cell>
                                <mat-cell *matCellDef="let row" [ngClass]="getTemplateName(row.emailTemplateName)">
                                    {{row.emailTemplateName}} </mat-cell>
                            </ng-container>

                            <!-- <ng-container matColumnDef="emailTemplateDescr">
                                                <mat-header-cell *matHeaderCellDef mat-sort-header> Email Template Description </mat-header-cell>
                                                <mat-cell *matCellDef="let row"> {{row.emailTemplateDescr}} </mat-cell>
                                            </ng-container> -->

                            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                            <mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selectRow(row)">
                            </mat-row>
                        </mat-table>
                    </div>
                    <div>
                        <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
                    </div>
                </div>
            </mat-card>
            <mat-card *ngIf="showEmailTemplateDetail" fxFlex.gt-md="65%" fxFlexFill>
                <email-template-modal [title]="emailTemplateData.emailTemplateName" [message]="emailTemplateData.emailTemplateName" [emailTemplateData]="emailTemplateData" [isReadOnly]="isReadOnly" [isReadOnlyList]="isReadOnlyList" (showEmailTemplateDetail)="onCancel($event)">
                </email-template-modal>
            </mat-card>
        </div>
    </mat-card>
</div>